import { Button, FormGroup, InputLabel, OutlinedInput } from '@mui/material'
import { useFormik } from 'formik'
import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { BeatLoader } from 'react-spinners'
import { Container, ContainerForm, ContainerFormRight, Title } from '../../styles/index.sty';
import AlertSnack from '../../components/Alert/AlertSnack'
import { useAuth } from '../../context/authContext'
import { useLists } from '../../context/listContext'
import { insertCityData, updateCityData } from '../../api/city.api'

export const AddCity = () => {
  const { config, config2 } = useAuth();
  const { fetchCityList } = useLists();
  const navigate = useNavigate();
  const location = useLocation();
  const [ loading, setLoading ] = useState(false);
  const [open, setOpen] = useState(false);
  const [ response, setResponse ] = useState({});
  const [ file, setFile ] = useState(null);
  const city = location?.state?.data;
  const formik = useFormik({
    initialValues: {
    city_name: city?.city_name,
    state_name: city?.state_name,
    },
    onSubmit: async values => {
      // console.log(values, file);
      setLoading(true);
      if (city) {
        const submit = await updateCityData({...values, city_id: city?.city_id, file }, config2);
        setResponse(submit);
        setOpen(true);
        fetchCityList();
        if(submit.status === "success") {
          navigate("/city");
        }
      } else {
        const submit = await insertCityData({...values, file}, config2);
        setResponse(submit);
        fetchCityList();
        setOpen(true);
        if(submit.status === "success") {
          navigate("/city");
        }
      }
    },
  });

  return (
    <>
    <Container>
      <Title variant='h5' className='w-[100%]'>Enter City Details.</Title>
      <ContainerForm>
      {open && <AlertSnack open={open} setOpen={setOpen} response={response} setLoading={setLoading} route="customers"/>}

      {loading ?
        <div className='items-center'>
          <BeatLoader color="#36d7b7" />
        </div>
        :
      <div style={{width : "60%", margin: "auto"}} >
        <FormGroup>
          <InputLabel htmlFor="city_name">City Name:<span className='text-[red]'>** </span> </InputLabel>
          <OutlinedInput
            name="city_name"
            placeholder="Enter City Name"
            id="city_name"
            type="text"
            value={formik.values.city_name}
            onChange={formik.handleChange}
            />
        </FormGroup><br/>
        <FormGroup>
          <InputLabel htmlFor="state_name">State Name:<span className='text-[red]'>** </span> </InputLabel>
          <OutlinedInput
            name="state_name"
            placeholder="Enter State Name"
            id="state_name"
            type="text"
            value={formik.values.state_name}
            onChange={formik.handleChange}
            />
        </FormGroup><br />
        <FormGroup>
          <InputLabel htmlFor="file">City Image:<span className='text-[red]'>** </span> </InputLabel>
          <OutlinedInput
            name="file"
            placeholder="Select Image"
            id="file"
            type="file"
            // value={file}
            onChange={(e) => setFile(e.target.files[0])}
          />
        </FormGroup>
        <div className='flex flex-row justify-between'>
          <Button
            type="button"
            variant='contained'
            color='info'
            onClick={() => navigate("/city")}
            style={{
              marginTop: "1rem",
              width: "48%"
            }}
            >
            Back
          </Button>
          <Button
            type="button"
            variant='contained'
            color='info'
            onClick={formik.handleSubmit}
            style={{
              marginTop: "1rem",
              width: "48%"
            }}
            >
            Save & Continue
          </Button>
        </div>
        {/* <Button
          fullWidth
          type="button"
          variant='contained'
          color='info'
          onClick={logList}
          style={{
            margin: "1rem auto"
          }}
          >
          Click Me TO Check
        </Button> */}
        </div>}
      </ContainerForm>
        <ContainerFormRight>
          <div className="flex flex-wrap">
            <p className="text-2xl mb-4 w-[100%]">
              <b>Image Preview</b>
            </p>
            <hr />
            {location?.pathname.includes("update") ? (
              <div className="w-[50%] mb-12">
                <p className="text-xl mb-4">
                  <b>Old Image</b>
                </p>
                <img
                  className=" m-auto"
                  src={city?.image_file}
                  alt={city?.image_name}
                />
              </div>
            ) : null}
            <div className="w-[50%]">
              <p className="text-xl mb-4">
                <b>New Image</b>
              </p>
              {file ? (
                <img
                  className=" m-auto"
                  src={URL.createObjectURL(file)}
                  alt={city?.image_name}
                />
              ) : (
                <p>No Image Selected</p>
              )}
            </div>
          </div>
        </ContainerFormRight>
    </Container>
    </>
  )
};
